export default "__VITE_ASSET__DEIcm06d__"